import React from 'react';
export function THFila(_a) {
    var width = _a.width, children = _a.children, align = _a.align, tip = _a.tip;
    return (React.createElement("th", { "data-tip": tip, style: { paddingTop: '1.25rem', minWidth: width, maxWidth: width, width: width, textAlign: align } },
        React.createElement("span", null,
            children,
            " ")));
}
export function THInput(_a) {
    var width = _a.width, children = _a.children, align = _a.align, tip = _a.tip;
    return (React.createElement("th", { style: { minWidth: width, maxWidth: width, width: width, textAlign: align }, "data-tip": tip }, children));
}
//# sourceMappingURL=THFila.js.map